import { Callout, FlexBox } from "@vp/swan";
import React from "react";

export const DebugInfoSelectionsFields = ({
  selections,
}: {
  selections: Record<string, string>;
}) => (
  <FlexBox mb={"3"} flexWrap="wrap">
    {Object.keys(selections).map(property => (
      <Callout key={property} skin="standard" variant="standard" size="standard" mr={"3"}>
        {`${property}: ${selections[`${property}`]}`}
      </Callout>
    ))}
  </FlexBox>
);
